import _axios from '@/utils/request'
// 查询咨询
export function selectAdvisory (params) {
    return _axios(
        'post',
        `/ms-shulan-hospital/v1/advisory/mngSelectAdvisory`,
        params
    )
}
// 回复
export function reply (params) {
    return _axios('post', `/ms-shulan-hospital/v1/advisory/reply`, params)
}

// 精彩留言修改
export function postWonderfulSort (params) {
    return _axios('post', `/ms-shulan-hospital/v1/advisory/wonderfulSort`, params)
}

// 点赞量修改
export function postWonderfulLikes (params) {
    return _axios('post', `/ms-shulan-hospital/v1/advisory/likes`, params)
}

// 修改排列编号
export function postWonderfulMsg (params) {
    return _axios('post', `/ms-shulan-hospital/v1/advisory/wonderfulMsg`, params)
}

// 展示
export function show (params) {
    return _axios('post', `/ms-shulan-hospital/v1/advisory/show`, params)
}
// 更改展示状态
export function postChangeShowType (params) {
    return _axios('post', `/ms-shulan-hospital/v1/advisory/showType`, params)
}
// 审核
export function review (params) {
    return _axios('post', `/ms-shulan-hospital/v1/advisory/review`, params)
}
// 修改标签
export function sign (params) {
    return _axios('post', `/ms-shulan-hospital/v1/advisory/sign`, params)
}

// -- 常见问题 -- start
// 获取时间
export function getTime () {
    return _axios('get', '/ms-shulan-hospital/v1/advisory/question/time/query')
}
// 更新时间
export function updateTime (time) {
    return _axios('post', `/ms-shulan-hospital/v1/advisory/question/time/update?time=${time}`)
}
// 问题列表
export function getProblemList (params) {
    return _axios('post', `/ms-shulan-hospital/v1/advisory/question/list`, params)
}
// 删除问题
export function deleteProblem (id) {
    return _axios('delete', `/ms-shulan-hospital/v1/advisory/question/delete/${id}`)
}
// 新增or更新问题
export function addOrEditProblem (params) {
    return _axios('post', `/ms-shulan-hospital/v1/advisory/question/increase`, params)
}
// -- 常见问题 -- end
